<!-- Button -->
@switch (place()) {
  @case ('sidebar') {
    <div class="fuse-vertical-navigation-item-wrapper">
      <div
        class="fuse-vertical-navigation-item flex w-full"
        [matMenuTriggerFor]="userActions"
        (menuOpened)="toggleMenu(true)"
        (menuClosed)="toggleMenu(false)"
      >
        <!-- Icon -->
        <mat-icon
          class="fuse-vertical-navigation-item-icon"
          [svgIcon]="'heroicons_outline:user-circle'"
        ></mat-icon>

        <!-- Title & Subtitle -->
        <div
          class="fuse-vertical-navigation-item-title-wrapper w-auto min-w-0 flex-[1_1_0%]"
        >
          <div class="fuse-vertical-navigation-item-title block truncate">
            {{ user()?.profile?.firstName || user()?.userInfo?.email }}
          </div>
        </div>
      </div>
    </div>
  }
  @case ('default') {
    <button
      mat-flat-button
      [matMenuTriggerFor]="userActions"
      (menuOpened)="toggleMenu(true)"
      (menuClosed)="toggleMenu(false)"
      class="flex items-center gap-3 p-[0.375rem] pr-4"
    >
      <mat-icon
        class="opacity-65"
        [svgIcon]="'heroicons_outline:user-circle'"
      ></mat-icon>
      <span class="text-default text-base font-semibold opacity-65">
        {{
          $safeNavigationMigration(user()?.userPlan?.planDetails?.plan)
            | titlecase
        }}
      </span>
    </button>
  }
}

@let isPremium = user()?.userPlan?.planDetails?.plan !== 'basic';
<mat-menu
  class="w-[calc(var(--fuse-vertical-navigation-width)-24px)] rounded-md bg-[#323744]"
  [xPosition]="'before'"
  #userActions="matMenu"
>
  <div class="flex items-center gap-5 px-4 py-2">
    <div class="flex max-w-44 flex-col">
      <span
        class="text-default truncate text-xl font-medium leading-5"
        [ngClass]="{ 'text-brandSecondary': isPremium }"
        >{{ user()?.profile?.firstName }} {{ user()?.profile?.lastName }}</span
      >
      <span class="text-default truncate text-base leading-5 opacity-65">{{
        user()?.userInfo?.email
      }}</span>
    </div>

    @if (isPremium) {
      <img
        src="/icons/custom/icon-diamond.svg"
        alt="Icon premium"
        class="ml-auto h-auto w-8 flex-0"
      />
    }
  </div>
  <mat-divider class="my-2"></mat-divider>
  <button mat-menu-item [routerLink]="'/settings/profile'">
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <span>Profile</span>
  </button>
  <button mat-menu-item [routerLink]="'/settings'">
    <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
    <span>Settings</span>
  </button>
  <mat-divider class="my-2"></mat-divider>
  <button mat-menu-item (click)="logout()">
    <mat-icon
      [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
    ></mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
